export enum CookieOptionType {
    TECHNICAL = 0,
    ANALYTICS = 1,
    MARKETING = 2,
}

export default class CookieOption {

    private readonly _type: CookieOptionType;
    private readonly _name: string;
    private readonly _description: string;
    private _allowed: boolean;

    constructor(type: CookieOptionType, name: string, description: string, allowed: boolean = false) {
        this._type = type;
        this._name = name;
        this._description = description;
        this._allowed = allowed;
    }

    getType(): CookieOptionType {
        return this._type;
    }

    getName(): string {
        return this._name;
    }

    getDescription(): string {
        return this._description;
    }

    isAllowed(): boolean {
        return this._allowed;
    }

    setAllowed(allowed: boolean): this {
        this._allowed = allowed;
        return this;
    }
}
